import React from "react";
import "./CarouselWrapper.css";
import Carousel from "react-bootstrap/Carousel";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import 'swiper/css/scrollbar';

function CarouselWrapper() {
  const banner1 = require("../assets/banner/MundiWord.png");


  return (
    <div className="carousel-wrapper">
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}
        modules={[Pagination, Navigation, Autoplay]}
        className="mySwiper"
      >
        <SwiperSlide>
          <img
            src={banner1}
            // className="d-block w-100 desk_img"
            alt="First Slide"
          />
        </SwiperSlide>

      </Swiper>

    </div>
  );
}

export default CarouselWrapper;
